export const sampleService = {
  nameFr: "Service de DJ",
  nameEn: "DJ Service",
  descriptionFr: "Ambiance garantie pour vos événements.",
  descriptionEn: "Guaranteed vibes for your events.",
  category: "musicAndEntertainment",
  brand: "DJ Max",
  imageUrl:
    "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/1743962233258-logo.png",
  price: "150,00",
  priceTypeId: "2", // Exemple: par heure
  isVisible: false,
  serviceNumber: "",
  location: {
    latitude: 46.803282,
    longitude: -71.242796,
    formattedAddress: "Québec, QC, Canada",
    regionId: 8138401,
  },
  availabilities: [],
  showAddress: true,
  productInventoryLimits: {
    inventoryMode: "fixed", // ou "unlimited"
    totalQuantity: 1,
    maxDuration: 8,
    returnMode: "none",
    returnPolicy: "",
  },
  tempImageUrl:
    "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/1743962233258-logo.png",
  updateAvailabilities: {
    added: ["2025-06-01", "2025-06-02", "2025-06-03"],
    removed: [],
  },
};
